import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";

console.log("make languages")

// const {i18n} = useTranslation()
// const current = i18n.language ? i18n.language : 'fr';

const isoLangs = {
    "ab":{
        "name":"Abkhaz",
        "nativeName":"аҧсуа",
        "include": false
    },
    "aa":{
        "name":"Afar",
        "nativeName":"Afaraf",
        "include": false
    },
    "af":{
        "name":"Afrikaans",
        "nativeName":"Afrikaans",
        "include": false
    },
    "ak":{
        "name":"Akan",
        "nativeName":"Akan",
        "include": false
    },
    "sq":{
        "name":"Albanian",
        "nativeName":"Shqip",
        "include": true
    },
    "am":{
        "name":"Amharic",
        "nativeName":"አማርኛ",
        "include": false
    },
    "ar":{
        "name":"Arabic",
        "nativeName":"العربية",
        "include": true
    },
    "an":{
        "name":"Aragonese",
        "nativeName":"Aragonés",
        "include": false
    },
    "hy":{
        "name":"Armenian",
        "nativeName":"Հայերեն",
        "include": true
    },
    "as":{
        "name":"Assamese",
        "nativeName":"অসমীয়া",
        "include": false
    },
    "av":{
        "name":"Avaric",
        "nativeName":"авар мацӀ, магӀарул мацӀ",
        "include": false
    },
    "ae":{
        "name":"Avestan",
        "nativeName":"avesta",
        "include": false
    },
    "ay":{
        "name":"Aymara",
        "nativeName":"aymar aru",
        "include": false
    },
    "az":{
        "name":"Azerbaijani",
        "nativeName":"azərbaycan dili",
        "include": true
    },
    "bm":{
        "name":"Bambara",
        "nativeName":"bamanankan",
        "include": false
    },
    "ba":{
        "name":"Bashkir",
        "nativeName":"башҡорт теле",
        "include": false
    },
    "eu":{
        "name":"Basque",
        "nativeName":"euskara, euskera",
        "include": false
    },
    "be":{
        "name":"Belarusian",
        "nativeName":"Беларуская",
        "include": true
    },
    "bn":{
        "name":"Bengali",
        "nativeName":"বাংলা",
        "include": false
    },
    "bh":{
        "name":"Bihari",
        "nativeName":"भोजपुरी",
        "include": false
    },
    "bi":{
        "name":"Bislama",
        "nativeName":"Bislama",
        "include": false
    },
    "bs":{
        "name":"Bosnian",
        "nativeName":"bosanski jezik",
        "include": true
    },
    "br":{
        "name":"Breton",
        "nativeName":"brezhoneg",
        "include": false
    },
    "bg":{
        "name":"Bulgarian",
        "nativeName":"български език",
        "include": true
    },
    "my":{
        "name":"Burmese",
        "nativeName":"ဗမာစာ",
        "include": false
    },
    "ca":{
        "name":"Catalan; Valencian",
        "nativeName":"Català",
        "include": true
    },
    "ch":{
        "name":"Chamorro",
        "nativeName":"Chamoru",
        "include": false
    },
    "ce":{
        "name":"Chechen",
        "nativeName":"нохчийн мотт",
        "include": false
    },
    "ny":{
        "name":"Chichewa; Chewa; Nyanja",
        "nativeName":"chiCheŵa, chinyanja",
        "include": false
    },
    "zh":{
        "name":"Chinese",
        "nativeName":"中文 (Zhōngwén), 汉语, 漢語",
        "include": true
    },
    "cv":{
        "name":"Chuvash",
        "nativeName":"чӑваш чӗлхи",
        "include": false
    },
    "kw":{
        "name":"Cornish",
        "nativeName":"Kernewek",
        "include": false
    },
    "co":{
        "name":"Corsican",
        "nativeName":"corsu, lingua corsa",
        "include": false
    },
    "cr":{
        "name":"Cree",
        "nativeName":"ᓀᐦᐃᔭᐍᐏᐣ",
        "include": false
    },
    "hr":{
        "name":"Croatian",
        "nativeName":"hrvatski",
        "include": false
    },
    "cs":{
        "name":"Czech",
        "nativeName":"česky, čeština",
        "include": true
    },
    "da":{
        "name":"Danish",
        "nativeName":"dansk",
        "include": true
    },
    "dv":{
        "name":"Divehi; Dhivehi; Maldivian;",
        "nativeName":"ދިވެހި",
        "include": false
    },
    "nl":{
        "name":"Dutch",
        "nativeName":"Nederlands, Vlaams",
        "include": true
    },
    "en":{
        "name":"English",
        "nativeName":"English",
        "include": true
    },
    "eo":{
        "name":"Esperanto",
        "nativeName":"Esperanto",
        "include": false
    },
    "et":{
        "name":"Estonian",
        "nativeName":"eesti, eesti keel",
        "include": false
    },
    "ee":{
        "name":"Ewe",
        "nativeName":"Eʋegbe",
        "include": false
    },
    "fo":{
        "name":"Faroese",
        "nativeName":"føroyskt",
        "include": false
    },
    "fj":{
        "name":"Fijian",
        "nativeName":"vosa Vakaviti",
        "include": false
    },
    "fi":{
        "name":"Finnish",
        "nativeName":"suomi, suomen kieli",
        "include": true
    },
    "fr":{
        "name":"French",
        "nativeName":"français, langue française",
        "include": true
    },
    "ff":{
        "name":"Fula; Fulah; Pulaar; Pular",
        "nativeName":"Fulfulde, Pulaar, Pular",
        "include": false
    },
    "gl":{
        "name":"Galician",
        "nativeName":"Galego",
        "include": false
    },
    "ka":{
        "name":"Georgian",
        "nativeName":"ქართული",
        "include": true
    },
    "de":{
        "name":"German",
        "nativeName":"Deutsch",
        "include": true
    },
    "el":{
        "name":"Greek, Modern",
        "nativeName":"Ελληνικά",
        "include": true
    },
    "gn":{
        "name":"Guaraní",
        "nativeName":"Avañeẽ",
        "include": false
    },
    "gu":{
        "name":"Gujarati",
        "nativeName":"ગુજરાતી",
        "include": false
    },
    "ht":{
        "name":"Haitian; Haitian Creole",
        "nativeName":"Kreyòl ayisyen",
        "include": false
    },
    "ha":{
        "name":"Hausa",
        "nativeName":"Hausa, هَوُسَ",
        "include": false
    },
    "he":{
        "name":"Hebrew (modern)",
        "nativeName":"עברית",
        "include": true
    },
    "hz":{
        "name":"Herero",
        "nativeName":"Otjiherero",
        "include": false
    },
    "hi":{
        "name":"Hindi",
        "nativeName":"हिन्दी, हिंदी",
        "include": true
    },
    "ho":{
        "name":"Hiri Motu",
        "nativeName":"Hiri Motu",
        "include": false
    },
    "hu":{
        "name":"Hungarian",
        "nativeName":"Magyar",
        "include": true
    },
    "ia":{
        "name":"Interlingua",
        "nativeName":"Interlingua",
        "include": false
    },
    "id":{
        "name":"Indonesian",
        "nativeName":"Bahasa Indonesia",
        "include": false
    },
    "ie":{
        "name":"Interlingue",
        "nativeName":"Originally called Occidental; then Interlingue after WWII",
        "include": false
    },
    "ga":{
        "name":"Irish",
        "nativeName":"Gaeilge",
        "include": true
    },
    "ig":{
        "name":"Igbo",
        "nativeName":"Asụsụ Igbo",
        "include": false
    },
    "ik":{
        "name":"Inupiaq",
        "nativeName":"Iñupiaq, Iñupiatun",
        "include": false
    },
    "io":{
        "name":"Ido",
        "nativeName":"Ido",
        "include": false
    },
    "is":{
        "name":"Icelandic",
        "nativeName":"Íslenska",
        "include": true
    },
    "it":{
        "name":"Italian",
        "nativeName":"Italiano",
        "include": true
    },
    "iu":{
        "name":"Inuktitut",
        "nativeName":"ᐃᓄᒃᑎᑐᑦ",
        "include": false
    },
    "ja":{
        "name":"Japanese",
        "nativeName":"日本語 (にほんご／にっぽんご)",
        "include": true
    },
    "jv":{
        "name":"Javanese",
        "nativeName":"basa Jawa",
        "include": false
    },
    "kl":{
        "name":"Kalaallisut, Greenlandic",
        "nativeName":"kalaallisut, kalaallit oqaasii",
        "include": false
    },
    "kn":{
        "name":"Kannada",
        "nativeName":"ಕನ್ನಡ",
        "include": false
    },
    "kr":{
        "name":"Kanuri",
        "nativeName":"Kanuri",
        "include": false
    },
    "ks":{
        "name":"Kashmiri",
        "nativeName":"कश्मीरी, كشميري‎",
        "include": false
    },
    "kk":{
        "name":"Kazakh",
        "nativeName":"Қазақ тілі",
        "include": true
    },
    "km":{
        "name":"Khmer",
        "nativeName":"ភាសាខ្មែរ",
        "include": true
    },
    "ki":{
        "name":"Kikuyu, Gikuyu",
        "nativeName":"Gĩkũyũ",
        "include": false
    },
    "rw":{
        "name":"Kinyarwanda",
        "nativeName":"Ikinyarwanda",
        "include": false
    },
    "ky":{
        "name":"Kirghiz, Kyrgyz",
        "nativeName":"кыргыз тили",
        "include": false
    },
    "kv":{
        "name":"Komi",
        "nativeName":"коми кыв",
        "include": false
    },
    "kg":{
        "name":"Kongo",
        "nativeName":"KiKongo",
        "include": false
    },
    "ko":{
        "name":"Korean",
        "nativeName":"한국어 (韓國語), 조선말 (朝鮮語)",
        "include": true
    },
    "ku":{
        "name":"Kurdish",
        "nativeName":"Kurdî, كوردی‎",
        "include": false
    },
    "kj":{
        "name":"Kwanyama, Kuanyama",
        "nativeName":"Kuanyama",
        "include": false
    },
    "la":{
        "name":"Latin",
        "nativeName":"latine, lingua latina",
        "include": false
    },
    "lb":{
        "name":"Luxembourgish, Letzeburgesch",
        "nativeName":"Lëtzebuergesch",
        "include": true
    },
    "lg":{
        "name":"Luganda",
        "nativeName":"Luganda",
        "include": false
    },
    "li":{
        "name":"Limburgish, Limburgan, Limburger",
        "nativeName":"Limburgs",
        "include": false
    },
    "ln":{
        "name":"Lingala",
        "nativeName":"Lingála",
        "include": false
    },
    "lo":{
        "name":"Lao",
        "nativeName":"ພາສາລາວ",
        "include": false
    },
    "lt":{
        "name":"Lithuanian",
        "nativeName":"lietuvių kalba",
        "include": true
    },
    "lu":{
        "name":"Luba-Katanga",
        "nativeName":"",
        "include": false
    },
    "lv":{
        "name":"Latvian",
        "nativeName":"latviešu valoda",
        "include": false
    },
    "gv":{
        "name":"Manx",
        "nativeName":"Gaelg, Gailck",
        "include": false
    },
    "mk":{
        "name":"Macedonian",
        "nativeName":"македонски јазик",
        "include": true
    },
    "mg":{
        "name":"Malagasy",
        "nativeName":"Malagasy fiteny",
        "include": false
    },
    "ms":{
        "name":"Malay",
        "nativeName":"bahasa Melayu, بهاس ملايو‎",
        "include": false
    },
    "ml":{
        "name":"Malayalam",
        "nativeName":"മലയാളം",
        "include": false
    },
    "mt":{
        "name":"Maltese",
        "nativeName":"Malti",
        "include": true
    },
    "mi":{
        "name":"Māori",
        "nativeName":"te reo Māori",
        "include": true
    },
    "mr":{
        "name":"Marathi (Marāṭhī)",
        "nativeName":"मराठी",
        "include": false
    },
    "mh":{
        "name":"Marshallese",
        "nativeName":"Kajin M̧ajeļ",
        "include": false
    },
    "mn":{
        "name":"Mongolian",
        "nativeName":"монгол",
        "include": false
    },
    "na":{
        "name":"Nauru",
        "nativeName":"Ekakairũ Naoero",
        "include": false
    },
    "nv":{
        "name":"Navajo, Navaho",
        "nativeName":"Diné bizaad, Dinékʼehǰí",
        "include": false
    },
    "nb":{
        "name":"Norwegian Bokmål",
        "nativeName":"Norsk bokmål",
        "include": false
    },
    "nd":{
        "name":"North Ndebele",
        "nativeName":"isiNdebele",
        "include": false
    },
    "ne":{
        "name":"Nepali",
        "nativeName":"नेपाली",
        "include": false
    },
    "ng":{
        "name":"Ndonga",
        "nativeName":"Owambo",
        "include": false
    },
    "nn":{
        "name":"Norwegian Nynorsk",
        "nativeName":"Norsk nynorsk",
        "include": false
    },
    "no":{
        "name":"Norwegian",
        "nativeName":"Norsk",
        "include": true
    },
    "ii":{
        "name":"Nuosu",
        "nativeName":"ꆈꌠ꒿ Nuosuhxop",
        "include": false
    },
    "nr":{
        "name":"South Ndebele",
        "nativeName":"isiNdebele",
        "include": false
    },
    "oc":{
        "name":"Occitan",
        "nativeName":"Occitan",
        "include": false
    },
    "oj":{
        "name":"Ojibwe, Ojibwa",
        "nativeName":"ᐊᓂᔑᓈᐯᒧᐎᓐ",
        "include": false
    },
    "cu":{
        "name":"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
        "nativeName":"ѩзыкъ словѣньскъ",
        "include": false
    },
    "om":{
        "name":"Oromo",
        "nativeName":"Afaan Oromoo",
        "include": false
    },
    "or":{
        "name":"Oriya",
        "nativeName":"ଓଡ଼ିଆ",
        "include": false
    },
    "os":{
        "name":"Ossetian, Ossetic",
        "nativeName":"ирон æвзаг",
        "include": false
    },
    "pa":{
        "name":"Panjabi, Punjabi",
        "nativeName":"ਪੰਜਾਬੀ, پنجابی‎",
        "include": false
    },
    "pi":{
        "name":"Pāli",
        "nativeName":"पाऴि",
        "include": false
    },
    "fa":{
        "name":"Persian",
        "nativeName":"فارسی",
        "include": true
    },
    "pl":{
        "name":"Polish",
        "nativeName":"polski",
        "include": true
    },
    "ps":{
        "name":"Pashto, Pushto",
        "nativeName":"پښتو"
    },
    "pt":{
        "name":"Portuguese",
        "nativeName":"Português",
        "include": true
    },
    "qu":{
        "name":"Quechua",
        "nativeName":"Runa Simi, Kichwa",
        "include": false
    },
    "rm":{
        "name":"Romansh",
        "nativeName":"rumantsch grischun",
        "include": false
    },
    "rn":{
        "name":"Kirundi",
        "nativeName":"kiRundi",
        "include": false
    },
    "ro":{
        "name":"Romanian, Moldavian, Moldovan",
        "nativeName":"română",
        "include": true
    },
    "ru":{
        "name":"Russian",
        "nativeName":"русский язык",
        "include": true
    },
    "sa":{
        "name":"Sanskrit (Saṁskṛta)",
        "nativeName":"संस्कृतम्",
        "include": false
    },
    "sc":{
        "name":"Sardinian",
        "nativeName":"sardu",
        "include": false
    },
    "sd":{
        "name":"Sindhi",
        "nativeName":"सिन्धी, سنڌي، سندھی‎",
        "include": false
    },
    "se":{
        "name":"Northern Sami",
        "nativeName":"Davvisámegiella",
        "include": false
    },
    "sm":{
        "name":"Samoan",
        "nativeName":"gagana faa Samoa",
        "include": false
    },
    "sg":{
        "name":"Sango",
        "nativeName":"yângâ tî sängö",
        "include": false
    },
    "sr":{
        "name":"Serbian",
        "nativeName":"српски језик",
        "include": true
    },
    "gd":{
        "name":"Scottish Gaelic; Gaelic",
        "nativeName":"Gàidhlig",
        "include": false
    },
    "sn":{
        "name":"Shona",
        "nativeName":"chiShona",
        "include": false
    },
    "si":{
        "name":"Sinhala, Sinhalese",
        "nativeName":"සිංහල",
        "include": false
    },
    "sk":{
        "name":"Slovak",
        "nativeName":"slovenčina",
        "include": false
    },
    "sl":{
        "name":"Slovene",
        "nativeName":"slovenščina",
        "include": true
    },
    "so":{
        "name":"Somali",
        "nativeName":"Soomaaliga, af Soomaali",
        "include": false
    },
    "st":{
        "name":"Southern Sotho",
        "nativeName":"Sesotho",
        "include": false
    },
    "es":{
        "name":"Spanish; Castilian",
        "nativeName":"español, castellano",
        "include": true
    },
    "su":{
        "name":"Sundanese",
        "nativeName":"Basa Sunda",
        "include": false
    },
    "sw":{
        "name":"Swahili",
        "nativeName":"Kiswahili",
        "include": false
    },
    "ss":{
        "name":"Swati",
        "nativeName":"SiSwati",
        "include": false
    },
    "sv":{
        "name":"Swedish",
        "nativeName":"svenska",
        "include": false
    },
    "ta":{
        "name":"Tamil",
        "nativeName":"தமிழ்",
        "include": false
    },
    "te":{
        "name":"Telugu",
        "nativeName":"తెలుగు",
        "include": false
    },
    "tg":{
        "name":"Tajik",
        "nativeName":"тоҷикӣ, toğikī, تاجیکی‎",
        "include": false
    },
    "th":{
        "name":"Thai",
        "nativeName":"ไทย",
        "include": true
    },
    "ti":{
        "name":"Tigrinya",
        "nativeName":"ትግርኛ",
        "include": false
    },
    "bo":{
        "name":"Tibetan Standard, Tibetan, Central",
        "nativeName":"བོད་ཡིག",
        "include": false
    },
    "tk":{
        "name":"Turkmen",
        "nativeName":"Türkmen, Түркмен",
        "include": false
    },
    "tl":{
        "name":"Tagalog",
        "nativeName":"Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
        "include": false
    },
    "tn":{
        "name":"Tswana",
        "nativeName":"Setswana",
        "include": false
    },
    "to":{
        "name":"Tonga (Tonga Islands)",
        "nativeName":"faka Tonga",
        "include": false
    },
    "tr":{
        "name":"Turkish",
        "nativeName":"Türkçe",
        "include": true
    },
    "ts":{
        "name":"Tsonga",
        "nativeName":"Xitsonga"
    },
    "tt":{
        "name":"Tatar",
        "nativeName":"татарча, tatarça, تاتارچا‎",
        "include": false
    },
    "tw":{
        "name":"Twi",
        "nativeName":"Twi",
        "include": false
    },
    "ty":{
        "name":"Tahitian",
        "nativeName":"Reo Tahiti",
        "include": false
    },
    "ug":{
        "name":"Uighur, Uyghur",
        "nativeName":"Uyƣurqə, ئۇيغۇرچە‎",
        "include": false
    },
    "uk":{
        "name":"Ukrainian",
        "nativeName":"українська",
        "include": true
    },
    "ur":{
        "name":"Urdu",
        "nativeName":"اردو",
        "include": false
    },
    "uz":{
        "name":"Uzbek",
        "nativeName":"zbek, Ўзбек, أۇزبېك‎",
        "include": false
    },
    "ve":{
        "name":"Venda",
        "nativeName":"Tshivenḓa",
        "include": false
    },
    "vi":{
        "name":"Vietnamese",
        "nativeName":"Tiếng Việt",
        "include": true
    },
    "vo":{
        "name":"Volapük",
        "nativeName":"Volapük",
        "include": false
    },
    "wa":{
        "name":"Walloon",
        "nativeName":"Walon",
        "include": false
    },
    "cy":{
        "name":"Welsh",
        "nativeName":"Cymraeg",
        "include": false
    },
    "wo":{
        "name":"Wolof",
        "nativeName":"Wollof",
        "include": false
    },
    "fy":{
        "name":"Western Frisian",
        "nativeName":"Frysk",
        "include": false
    },
    "xh":{
        "name":"Xhosa",
        "nativeName":"isiXhosa",
        "include": false
    },
    "yi":{
        "name":"Yiddish",
        "nativeName":"ייִדיש",
        "include": false
    },
    "yo":{
        "name":"Yoruba",
        "nativeName":"Yorùbá",
        "include": false
    },
    "za":{
        "name":"Zhuang, Chuang",
        "nativeName":"Saɯ cueŋƅ, Saw cuengh",
        "include": false
    }
}

let current = 'fr';
let priority = ['default', current];

['fr', 'en', 'uk', 'de', 'it', 'es', 'pl', 'po'].forEach(iso=>{if (iso !== current)priority.push(iso)});

let languages = Object.keys(isoLangs)
    .filter(iso=>isoLangs[iso].include === true)
    .map(iso=>({
        iso: iso.toLowerCase(),
        value: isoLangs[iso],
        ord: priority.includes(iso.toLowerCase()) ? priority.indexOf(iso.toLowerCase()) : priority.length,
        flag: countryToFlag(iso)
    }))
    .sort((a,b)=> a.ord===b.ord ? 0 : (a.ord > b.ord ? 1 : -1));

let languagesKeys = languages.map(lang=>lang.iso)

console.debug("Languages are made", {languages, languagesKeys, priority})

// This is the HOOK
export function useLanguages() {
    const {i18n} = useTranslation();
    const [i18lang, setI18lang] = useState(i18n.language);
    useEffect(()=>{
        if (i18lang.toLowerCase() !== current) {
            // TODO remake languages
        }
    }, [i18lang])
    return {languages, languagesKeys, priority};
}

function countryToFlag(isoCode) {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

export function toLowerKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
        accumulator[key.toLowerCase()] = obj[key];
        return accumulator;
    }, {});
}



